export { default } from './contacts';
